import { useMutation } from 'react-query';

import { updateGroup } from '../infrastructure/update-group';
import { useInvalidateAllGroups } from './utils/invalidate-all-groups';

export const useUpdateGroupMutation = () => {
    const invalidateAll = useInvalidateAllGroups();

    return useMutation({
        mutationFn: updateGroup,
        onSuccess: () => {
            invalidateAll();
        },
    });
};
